<style scoped>
    * {
        font-family: PingFangSC-Semibold, PingFang SC;
    }

    .wrapActive {
        background: #F4F8FD !important;
    }

    .wrap {
        width: 90%;
        margin: 0.1rem auto;
        padding: 0.15rem 0.15rem;
        border-radius: 0.08rem;
        background: #F9F9F9;
    }

    .wrap .title {
        font-size: 0.16rem;
        font-weight: 600;
        color: #333333;
    }

    .wrap .message {
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
        margin: 0.1rem 0rem;
    }

    .wrap .time {
        font-size: 0.12rem;
        font-weight: 400;
        color: #999999;
    }

    .sendBtn {
        width: 90%;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        line-height: 0.5rem;
        text-align: center;
        left: 0;
        right: 0;
        margin: 0.1rem auto;
        position: fixed;
        bottom: 0.2rem;
    }

    .sendBtn span {
        font-size: 0.16rem;
        font-weight: 500;
        color: #FFFFFF;
    }

    .toast .title {
        font-size: 0.18rem;
        font-weight: 500;
        color: #2F2F2F;
        text-align: center;
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
    }

    .toast .content {
        font-size: 0.14rem;
        font-weight: 400;
        color: #5E5E5E;
        width: 90%;
        margin: 0.1rem auto;
    }

    .toast .message {
        text-align: center;
        padding: 0.1rem;
        border: 1px solid #EEEEEE;
        margin-bottom: 0.05rem;
    }

    .confirm {
        width: 90%;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        line-height: 0.5rem;
        text-align: center;
        margin: 0.3rem auto;
    }

    .confirm span {
        font-size: 0.16rem;
        font-weight: 500;
        color: #FFFFFF;
    }

    .configActive {
        background: #F4F8FD;
        border: 1px solid #527AF5;
        color: #527AF5;
    }

</style>
<template>
    <div style="background: #ffffff;">
        <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
            <div v-for="(item,index) in messages" :key="index" class="wrap" :class="{wrapActive:item.type==0}">
                <div class="title">
                    {{item.title}}
                </div>
                <div class="message">
                    {{item.message}}
                </div>
                <div class="time">
                    {{item.time}}
                </div>
            </div>
        </van-pull-refresh>
        <div class="sendBtn" @click="toast">
            <span>发送消息</span>
        </div>

        <van-popup
                v-model:show="showBottom"
                round
                closeable
                position="bottom"
        >
            <div class="toast">
                <div class="title">
                    模板消息
                </div>
                <div class="content">
                    <div v-for="(item,index) in configs" :key="index" class="message"
                         :class="{'configActive':index==configIndex}" @click="configIndex=index">
                        {{item}}
                    </div>
                </div>
                <div class="confirm" @click="sendMessage">
                    <span>确认</span>
                </div>
            </div>

        </van-popup>

        <Loading :isShow="loading"></Loading>
    </div>
</template>
<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                refreshLoading:true,
                loading: false,
                showBottom: false,
                orderId: 0,
                configs: [],
                messages: [],
                configIndex: 0,

            };
        },
        created() {
            this.util.title("联系记录");
            this.orderId = this.$route.query.orderId;
            this.getConfigs();
            this.queryList();
        },
        methods: {
            getConfigs() {
                let param = {
                    source: 1,
                    orderId: this.orderId
                };
                this.$get("/app/v1/messageRecord/configs", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.configs = res.data;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            onRefresh() {
                setTimeout(() => {
                    this.refreshLoading = false;
                    this.queryList();
                }, 500)
            },
            queryList() {
                let param = {
                    orderId: this.orderId
                };
                this.loading = true;
                this.$get("/app/v1/messageRecord/queryList", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.loading = false;
                            this.messages = res.data;
                        } else {
                            this.loading = false;
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            toast() {
                this.showBottom = true;
            },
            sendMessage() {
                let formData = new FormData();
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                formData.append('orderId', this.orderId);
                var message = this.configs[this.configIndex];
                formData.append('message', message);
                this.$post("/app/v1/messageRecord/sendMessage", formData, config)
                    .then((res) => {
                        this.showBottom = false;
                        if (res.code == 200) {
                            this.queryList();
                            this.util.toast({msg: "发送成功，请等待回复"});
                        } else {
                            this.util.toast({msg: res.message, type: "fail"});
                        }
                    })
                    .catch((error) => {
                        this.util.toast({msg: res.message, type: "fail"});
                    });
            },

        },
    };
</script>
